<div class="dialog-principal">
    <div class="custom-dialog-content">
        <div mat-dialog-content>{{message}}</div>
        <div *ngIf="this.boolRenovar" mat-dialog-content>¿Desea renovarla?</div>
    </div>
    <div mat-dialog-actions>
        <div class="row flex-wrap justify-content-center">
            <div class="col-lg-6 col-md-8 col-sm-8 col-xs-12">
                <button mat-button (click)="clickCancelar()" class="mat-button mat-primary" class="BotonAgregar"
                    color="primary" [disabled]="boMostrarSpinner">Cerrar Sesión</button>
                <!-- <button mat-button (click)="clickRenovar()" class="mat-button mat-primary" class="BotonAgregar"
            color="primary">Renovar</button> -->
            </div>
            <div class="col-lg-6 col-md-8 col-sm-8 col-xs-12">
                <button *ngIf="this.boolRenovar" mat-button (click)="clickRenovar()" class="mat-button mat-primary" class="BotonAgregar"
                    color="primary" [disabled]="boMostrarSpinner">
                    <span *ngIf="!boMostrarSpinner; else spinner">Renovar Sesión</span>
                    <ng-template #spinner>
                        <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                        <span class="sr-only">Loading...</span>
                    </ng-template>
                </button>
            </div>
        </div>
    </div>
</div>